import {
  ArrowDown24,
  DataViewAlt24,
  DocumentUnknown24,
  Download24,
} from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { tree } from "d3";
import * as XLSX from "xlsx";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "NUIT",
    key: "nuit",
  },
  {
    header: "Sede",
    key: "companyHeadquarters",
  },
  {
    header: "Estado",
    key: "currentStatusCode",
  },
  {
    header: "Elegível",
    key: "isEligible",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url1, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li className="mr-1">
      <Link to={url1} title="Consultar Candidatura">
        <DataViewAlt24 />
      </Link>
    </li>
    {/* <li>
      <Link to={url2} title="Consultar Questionário">
        <DocumentUnknown24 />
      </Link>
    </li> */}
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url1={"../candidature/" + id}
        url2={"../self-knowledge-questionnaire/" + id}
      />
    );
  }

  if (cell.info.header === "currentStatusCode") {
    return cell.value == 1 ? "Em aberto" : "Submetida";
  }

  if (cell.info.header === "isEligible") {
    return cell.value ? "Sim" : "Não";
  }

  return cell.value;
};

const ListCandidaturesPage = () => {
  const [candidatures, setCandidatures] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get("/applications/search/q?size=" + size);
      getApplicationData(response);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        "/applications/search/q?page=" + pag + "&size=" + pageSize
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      const response = await http.get(
        `/applications/search/q?name=${data.name}&phoneNumber=${data.phoneNumber}`
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const exportHeaders = [
    // Basic Information
    { field: "uuid", headerName: "UUID" },
    { field: "dataUseConsent", headerName: "Consentimento de Uso de Dados" },

    // Company Demographics
    { field: "companyName", headerName: "Nome da Empresa" },
    { field: "nuit", headerName: "NUIT" },
    {
      field: "startYearOfActivities",
      headerName: "Ano de Início das Atividades",
    },
    { field: "companyHeadquarters", headerName: "Sede da Empresa" },
    { field: "provinceName", headerName: "Província" },
    { field: "districtName", headerName: "Distrito" },

    // Legal Information
    { field: "legalFormDesc", headerName: "Forma Legal" },
    { field: "otherLegalForm", headerName: "Outra Forma Legal" },
    {
      field: "isRegisteredAndHasPermit",
      headerName: "Registada e possui Alvará",
    },
    { field: "permitDetails", headerName: "Detalhes do Álvara" },
    { field: "hasLicense", headerName: "Possui Licença" },
    { field: "licenseDetails", headerName: "Detalhes da Licença" },
    {
      field: "hasFinancialStatements",
      headerName: "Possui Demonstrações Financeiras",
    },

    // Contact Information
    { field: "applicationResponsibleName", headerName: "Nome do Responsável" },
    { field: "responsiblePosition", headerName: "Cargo do Responsável" },
    { field: "contactPerson", headerName: "Pessoa de Contato" },
    { field: "contactPersonRole", headerName: "Função da Pessoa de Contato" },
    { field: "phoneNumber", headerName: "Número de Telefone" },
    { field: "email", headerName: "Email" },
    { field: "website", headerName: "Website" },

    // Project Details
    { field: "projectName", headerName: "Nome do Projeto" },
    { field: "projectObjectives", headerName: "Objetivos do Projeto" },
    { field: "projectContent", headerName: "Conteúdo do Projeto" },
    { field: "projectGoals", headerName: "Metas do Projeto" },
    { field: "targetClientProfile", headerName: "Perfil do Cliente Alvo" },
    {
      field: "alignmentWithProgramObjectives",
      headerName: "Alinhamento com Objetivos do Programa",
    },
    {
      field: "expectedFundingAmountFromConecta",
      headerName: "Montante de Financiamento Esperado",
    },

    // Technical Experience
    {
      field: "yearsOfExperienceInSoftwareDevDesc",
      headerName: "Anos de Experiência em Desenvolvimento de Software",
    },
    {
      field: "hasExperienceInDigPlatformDev",
      headerName: "Experiência em Desenvolvimento de Plataformas Digitais",
    },

    // Program Relationship
    {
      field: "hasRelationshipWithProgramEmployees",
      headerName: "Relacionamento com Funcionários do Programa",
    },
    { field: "relationshipDetails", headerName: "Detalhes do Relacionamento" },

    // Status
    { field: "currentStatusDesc", headerName: "Estado Atual" },
  ];

  const exportData = async () => {
    setIsLoading(true);
    try {
      const response = await http.get(`/applications/export`);

      const mappedData = response.data.map((item) => {
        const newItem = {};
        exportHeaders.forEach((header) => {
          newItem[header.headerName] = item[header.field];
        });
        return newItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Candidaturas");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      // Create a link element
      const currentDateTime = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .replace("T", "_")
        .replace("Z", "");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `export_candidaturas_${currentDateTime}.xlsx`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
    } catch (error) {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const getApplicationData = (response) => {
    console.log(response.data);
    const data = response.data.content.map((c) => ({
      id: c.uuid,
      name: c.companyName,
      nuit: c.nuit,
      companyHeadquarters: c.companyHeadquarters,
      currentStatusCode: c.currentStatusCode,
      isEligible: c.isEligible,
    }));
    setCandidatures(data);
    setCount(response.data.totalElements);
    setIsLoading(false);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Candidaturas">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <div className="form-buttons">
        <p></p>
        <Button kind="ghost" onClick={exportData}>
          <Download24 /> Exportar
        </Button>
      </div>

      <DataTable
        rows={candidatures}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome"
                        {...register("name")}
                      />
                    </Column>

                    {/* <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="phoneNumber"
                        labelText=""
                        placeholder="Telefone"
                        {...register("phoneNumber")}
                      />
                    </Column> */}
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default ListCandidaturesPage;
